import React from 'react';
import Helpers from 'utils/helpers';
import useInput from 'hooks/input';
import './radio.css';

export default function RadioInput(props) {
  const { setInputRef, isInputValid } = useInput({ hasCustomError: props.isInvalid });

  const checked = props.checked;
  const disabled = props.readOnly || props.readonly || props.disabled;

  const handleChange = (event) => {
    if (props.onChange) {
      props.onChange(event);
    }
    if (props.onValueChange) {
      props.onValueChange(event.target.checked);
    }
  };

  const getContainerClass = () => {
    let classNames = ['custom-radio-container', props.className];
    if (!Helpers.String.isEmpty(props.size)) {
      classNames.push(`custom-radio-container-${props.size}`);
    }
    if (Helpers.Object.exists(props.block)) {
      classNames.push('custom-radio-container-block');
    }
    if (Helpers.String.isEmpty(props.label)) {
      classNames.push('custom-radio-container-nolabel');
    }
    return Helpers.String.join(classNames);
  };

  const getClass = () => {
    let classNames = ['custom-radio'];
    if (props.variant) {
      classNames.push(`custom-radio-${props.variant}`);
    }
    else {
      classNames.push('custom-radio-app');
    }
    if (props.disabled) {
      classNames.push('disabled');
    }
    if (!isInputValid()) {
      classNames.push('invalid');
    }
    if (props.isInvalid && props.alwaysShowValidity) {
      classNames.push('is-invalid');
    }
    else if (props.isValid && props.alwaysShowValidity) {
      classNames.push('is-valid');
    }
    return Helpers.String.join(classNames);
  };

  return (
    <span className={getContainerClass()}>
      <label className={getClass()}>
        <input
          type='radio'
          className='custom-radio-input'
          name={props.name || props.group}
          checked={checked}
          onChange={handleChange}
          ref={setInputRef}
          disabled={disabled}
        />
        <span className='custom-radio-checkmark'></span>
        {props.label && <span className='custom-radio-label'>{props.label}</span>}
        {props.children && <span>{props.children}</span>}
      </label>
    </span>
  );
}